<template>
  <div>
    <z-modal :open="confirmModalOpen" @closed="closeModal()">
      <div>
        <div class="z-title z-title--small spacer-bottom-s">
          Oops... Ocorreu um erro no nosso sistema
        </div>

        <div class="z-text spacer-bottom-m">
          Notamos um erro no nosso sistema, mas não se preocupe!
        </div>

        <div class="z-text spacer-bottom-m">
          Você pode entrar em contato através do WhatsApp para solicitar um acordo.
        </div>
      </div>

      <router-link
        tag="button"
        :to="{ name: 'contacts' }"
        class="z-button z-button--primary z-button--block"
      >
        Falar com a gente
      </router-link>
    </z-modal>

    <div class="bill-card__bill-status">
      <div class="bill-card__bill-status-icon-wrapper">
        <z-icon class="bill-card__bill-status-icon" :icon="['fas', 'exclamation-triangle']" size="large" />
      </div>

      <div class="bill-card__bill-status-title">
        Pagamento em atraso
      </div>

      <div class="bill-card__bill-status-overdues-count">
        Você possui {{ hasMoreThanTwoOverdueBill
          ? `${overdueBills.length} mensalidades pendentes`
          : '1 mensalidade pendente'
        }}
      </div>

      <div class="bill-card__bill-status-text" v-if="withScholarship && hasMoreThanTwoOverdueBill">
        Regularize essas <strong>pendências</strong> para continuar com sua bolsa de estudos.
      </div>

      <div class="bill-card__bill-status-text" v-else-if="withScholarship && !hasMoreThanTwoOverdueBill">
        Regularize essa <strong>pendência</strong> para continuar com sua bolsa de estudos.
      </div>
    </div>

    <div class="z-button-wrapper">
      <router-link
        tag="button"
        :to="{ name: 'overdue-bills' }"
        :class="['z-button', `z-button--${detailsButtonVariant}`]"
      >
        Ver detalhes
      </router-link>

      <button class="z-button z-button--primary" @click="openModal" v-if="hasMoreThanTwoOverdueBill">
        Fazer acordo
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bill-card__bill-status-title {
  font-size: rem(12);
  font-weight: var(--font-weight-semi-bold);
  margin-bottom: var(--space-small);
  text-transform: uppercase;
}

.bill-card__bill-status-overdues-count {
  font-size: rem(24);
  font-weight: var(--font-weight-semi-bold);
  margin-bottom: var(--space-medium);
}

.bill-card__bill-status-text {
  font-size: rem(16);
  margin-bottom: var(--space-medium);
}

.bill-card__bill-status-icon {
  color: var(--color-font-danger);
}

.bill-card__bill-status-icon-wrapper {
  background-color: var(--color-background-danger);
  border-radius: 50%;
  margin-bottom: var(--space-small);
  padding: rem(10);
  width: fit-content;
}
</style>

<script>
export default {
  data() {
    return {
      confirmModalOpen: false,
    };
  },
  props: {
    overdueBills: {
      type: Array,
      default: () => ([]),
    },
    withScholarship: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openModal() {
      this.$gambit.trackInteraction({
        name: 'agreement button clicked',
        interactionType: 'button_click',
        visitHash: sessionStorage.getItem('visitHash'),
      });

      this.confirmModalOpen = true;
    },
    closeModal() {
      this.confirmModalOpen = false;
    },
  },
  computed: {
    hasMoreThanTwoOverdueBill() {
      return this.overdueBills.length >= 2;
    },
    detailsButtonVariant() {
      return this.hasMoreThanTwoOverdueBill ? 'secondary' : 'primary';
    },
  },
};
</script>
